import * as React from 'react';
import styled from 'styled-components';
import { Input, Icon, Spin } from 'components';

const INPUT_PLACEHOLDER = 'Name, Address, Details' as const;

export interface ContactsSearchProps {
  onChange?: (input: string) => void;
  loading?: boolean;
}

const ContactsSearch: React.FC<ContactsSearchProps> = ({
  onChange,
  loading,
}) => {
  const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) onChange(event.currentTarget.value);
  };
  return (
    <ContactsSearchInput
      data-cy="contact-search-bar"
      prefix={
        loading ? <Spin size="small" /> : <Icon type="search" color="gray6" />
      }
      onChange={onInputChange}
      placeholder={INPUT_PLACEHOLDER}
      allowClear
    />
  );
};

export default ContactsSearch;

const ContactsSearchInput = styled(Input)`
  && {
    flex: 1 1 100%;
    max-width: 390px;
  }
`;
